import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Skeleton from 'react-loading-skeleton'

import { fetchAdminAvailabilityRequestMatches } from '../../actions/adminActions'
import { AdminHeader } from './Index'
import { AdminTd, AdminTh, AdminTable } from './Tables'

export const AvailabilityRequestMatches = () => {
  const dispatch = useDispatch()
  const availabilityRequestMatches = useSelector(store => store.admin.availabilityRequestMatches)

  useEffect(() => {
    dispatch(fetchAdminAvailabilityRequestMatches())
  }, [])

  return (
    <div>
      <AdminHeader>AvailabilityRequestMatches</AdminHeader>

      <AdminTable>
        <thead>
          <tr>
            <AdminTh>Id</AdminTh>
            <AdminTh>User</AdminTh>
            <AdminTh>Matches</AdminTh>
            <AdminTh>Actives</AdminTh>
            <AdminTh>Facility</AdminTh>
          </tr>
        </thead>
        {availabilityRequestMatches.map((obj, index) => (
          <tr key={index} className={obj.id && index % 2 !== 0 && 'bg-green-100'}>
            <AdminTd>{obj.id || <Skeleton width="5ch" />}</AdminTd>
            <AdminTd>{(obj.id && obj.user.email) || <Skeleton width="25ch" />}</AdminTd>
            <AdminTd>{obj.id ? obj.availabilityMatchesCount : <Skeleton width="4ch" />}</AdminTd>
            <AdminTd>{obj.id ? obj.availabilityMatchesActiveCount : <Skeleton width="4ch" />}</AdminTd>
            <AdminTd>{(obj.id && obj.availabilityRequest.facility.name) || <Skeleton width="40ch" />}</AdminTd>
          </tr>
        ))}
      </AdminTable>
    </div>
  )
}

export default AvailabilityRequestMatches
